/**
 * Gmail App - Mail Application for Gmail
 *
 * Two web-accessible-resource groups, both scoped rather than exposed to every origin.
 * oauth2callback.html is matched to netvolk.online, accounts.google.com and
 * gmailapp.store; images/search.png is matched only to mail.google.com. With no
 * use_dynamic_url the URLs are fixed, so from netvolk.online oauth2callback.html is
 * fetchable — but from anywhere outside those matches the resources are unreachable and
 * a negative proves nothing.
 *
 * Manifest verified against version 2.3.13.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gmdbalikolapfnbecncancmjgmmdnkkk';

export const gmailApp: ExtensionDefinition = {
  id: ID,
  name: 'Gmail App - Mail Application for Gmail™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://netvolk.online',
  notes:
    'WAR are origin-scoped, not exposed to every page. oauth2callback.html is reachable ' +
    'from netvolk.online, so only that site can detect it here.',
  signals: [
    {
      id: 'war-oauth2callback-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch oauth2callback.html — static, exposed only to netvolk.online and a couple ' +
        'of other origins.',
      weight: 1,
      run: () => probeFetch(ID, 'oauth2callback.html'),
    },
  ],
};
